import { render, staticRenderFns } from "./elc.vue?vue&type=template&id=38bc8e02"
import script from "./elc.vue?vue&type=script&lang=js"
export * from "./elc.vue?vue&type=script&lang=js"
import style0 from "./elc.vue?vue&type=style&index=0&id=38bc8e02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports